import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    dmUserCode: {
        name: () => '库表域代码',
    },

    dmName: {
        name: () => '库表域名称',
        required: () => true,
    },
})
